import { AlertTriangle } from 'lucide-react';
import { CodeArtifact } from './CodeArtifact';

interface Props {
  /** 레거시 `react` kind artifact 의 JSX 소스. 렌더하지 않고 코드만 표시. */
  jsx: string;
}

/**
 * DEPRECATED — `react` kind 는 Sandpack 런타임 (외부 CDN 의존) 에 기반했으나 사내망/오프라인
 * 배포 환경에서 작동하지 않아 제거됨. 기존 DB 에 저장된 레거시 row 를 깨지 않고 보여주기 위해
 * 코드 뷰 + 재생성 안내만 표시한다. 새 대시보드는 `html` kind 로 생성됨.
 */
export function ReactArtifact({ jsx }: Props) {
  return (
    <div className="flex h-full min-h-0 w-full flex-col bg-surface">
      <div className="shrink-0 border-b border-border bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:bg-amber-950/40 dark:text-amber-200">
        <div className="flex items-start gap-2">
          <AlertTriangle className="mt-0.5 size-3.5 shrink-0" />
          <div>
            <div className="font-medium">React artifact 는 더 이상 지원되지 않습니다.</div>
            <div className="mt-0.5 text-amber-800/80 dark:text-amber-200/70">
              채팅에 "이 대시보드 html 로 다시 만들어줘" 라고 요청하면 html kind 로 새 버전이
              생성됩니다.
            </div>
          </div>
        </div>
      </div>
      <div className="min-h-0 flex-1">
        <CodeArtifact source={jsx} />
      </div>
    </div>
  );
}
